import { FC } from "react";
import { IonCol, IonItem } from "@ionic/react";

interface ComparisonBarComponentProps {
    values: number[];
    colors: string[];
}

const ComparisonBarComponent: FC<ComparisonBarComponentProps> = ({
    values,
    colors,
}) => {
    // filter out any values that are 0 to ensure the bar rounds properly
    const filteredValues = values.filter((value) => value > 0);

    return (
        <IonItem lines="none">
            <IonCol>
                <div className="comparison-bar">
                    {filteredValues.map((value, index) => {
                        return (
                            <div
                                key={index}
                                className="comparison-item"
                                style={{
                                    width: value * 100 + "%",
                                    backgroundColor: colors[index],
                                }}
                            />
                        );
                    })}
                </div>
            </IonCol>
        </IonItem>
    );
};

export default ComparisonBarComponent;
